class HeaderController {
    static $inject = ["$location", "tpsrService"];

    constructor($location, tpsrService) {
        this.$location = $location;
        this.tpsr = tpsrService;
    }

    $onInit() {
        this.showNpcAdmins = false;
        this.showUsers = false;
        this.showItems = false;
        this.showMyOrders = false;

        if (this.tpsr.user) {
            this.showNpcAdmins = this.tpsr.user.is_npc_admin;
            this.showUsers = this.tpsr.user.is_admin || this.tpsr.user.is_manager;
            this.showItems = this.tpsr.user.is_admin;
            this.showMyOrders = (this.tpsr.user.is_admin || this.tpsr.user.is_manager) && this.tpsr.user.city_id;
        }
    }

    isPath = testPath => this.$location.path() === testPath;

    logout = () => {
        return this.tpsr.logout().then(() => {
            this.$location.url("/");
        })
    };
}

angular
    .module("app")
    .component("header", { // header
        templateUrl: "src/app/_shared/header/header.html",
        controller: HeaderController
    });
